import CustomerId            from "../../../../domain/customer/CustomerId";
import CustomerIds           from "../../../../domain/customer/CustomerIds";
import Count                 from "../../../../domain/fundamentals/count/Count";
import FetchStatusRepository from "../../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository      from "../../../../domain/fundamentals/message/notify/NotifyRepository";
import CurrentPage           from "../../../../domain/fundamentals/pagination/CurrentPage";
import Pagination            from "../../../../domain/fundamentals/pagination/Pagination";
import TotalPage             from "../../../../domain/fundamentals/pagination/TotalPage";
import CreatedAt             from "../../../../domain/fundamentals/trail/CreatedAt";
import Trail                 from "../../../../domain/fundamentals/trail/Trail";
import UpdatedAt             from "../../../../domain/fundamentals/trail/UpdatedAt";
import MailGroup             from "../../../../domain/mail/group/MailGroup";
import MailGroupId           from "../../../../domain/mail/group/MailGroupId";
import MailGroupName         from "../../../../domain/mail/group/MailGroupName";
import MailGroupRepository   from "../../../../domain/mail/group/MailGroupRepository";
import MailGroups            from "../../../../domain/mail/group/MailGroups";
import FetchStatusDataSource from "../../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import MailGroupDataSource   from "../../../../infrastructure/datasource/mail/group/MailGroupDataSource";
import NotifyDataSource      from "../../../../infrastructure/datasource/notify/NotifyDataSource";

class GetMailGroups {
  private readonly mailGroupRepository: MailGroupRepository = new MailGroupDataSource(this.dispatch);
  private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(this.dispatch);
  private readonly notifyRepository: NotifyRepository = new NotifyDataSource(this.dispatch);

  constructor(private readonly dispatch) {
  }

  public async execute(currentPage: CurrentPage) {
    this.fetchStatusRepository.start();
    try {
      const response = await this.mailGroupRepository.findByPage(currentPage);
      const list: MailGroup[] = response.data.mailGroups.map(mailGroup => new MailGroup(
        new MailGroupId(mailGroup.id),
        new MailGroupName(mailGroup.name),
        new CustomerIds(mailGroup.customerIds.map(customerId => new CustomerId(customerId))),
        new Trail(
          new CreatedAt(mailGroup.trail.createdAt),
          new UpdatedAt(mailGroup.trail.updatedAt),
        )
      ));
      const pagination: Pagination = new Pagination(new CurrentPage(response.data.pagination.current), new TotalPage(response.data.pagination.total));
      const count: Count = new Count(response.data.count);
      this.mailGroupRepository.setMailGroups(new MailGroups(list, pagination, count));
    } catch (e) {
      this.notifyRepository.fetchFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default GetMailGroups;
